import FlashMessage from '../common/flash-message.component'
import HTTPClient from '../common/http-client'
import AppConstants from '../constants/app.constants'
import ErrorCdMsgConstants from '../constants/error-cd-msg.constants'
import HTTPUtils from './http.util'
import { store } from '@/store.js'

export default class ErrorMessageUtils {
  /**
   * ビルドエラーメッセージ。
   * @param {string} errCd エラーコード
   * @param {string} errMsg エラーメッセージ
   * @returns フォーマットされたエラーコードとエラーメッセージ
   */
  static buildErrorMessage(errCd, errMsg) {
    if (!errCd || !errMsg) {
      return ''
    }
    // エラーメッセージがすでにエラーコードを内包している場合、そのまま返す
    if (errMsg.includes(errCd)) {
      return errMsg
    }
    return '【' + errCd + '】' + errMsg
  }

  /**
   * 切断エラーメッセージ表示チェック。
   *
   * @param {ErrorResponse} error エラー応答
   * @param {boolean} displayCloseIconForServerErrorFlag サーバーエラーフラグのクローズアイコン表示
   * @returns true: サーバーエラーメッセージ, false: サーバーのエラーメッセージではありません
   */
  static async checkToShowDisconnectionErrorMsg(error, displayCloseIconForServerErrorFlag) {
    // 002エラーが表示されることを確認
    if (this.checkToShowOfflineMsg()) {
      return true
    }

    switch (error.code) {
      case ErrorCdMsgConstants.FUNC_SOCKET_DISCONNECTION_ERR_CD: // ソケット切断エラーコード
        break

      case ErrorCdMsgConstants.FUNC_SOCKET_CONNECTION_ERR_CD: // ソケット再接続エラーコード
        try {
          await HTTPClient.getInstance().http.get(AppConstants.HEALTH_CHECK_URL)
        } catch (error) {
          // エラー001と002をチェックする
          if (this.checkToShowOfflineMsg() || this.checkToShowServerDisconnectionErrorMsg(error, displayCloseIconForServerErrorFlag)) {
            return true
          }

          // エラー001を表示
          if (!this.connected) {
            FlashMessage.getInstance().showDisconnectionErrorCdMsg(
              ErrorCdMsgConstants.FUNC_SERVER_CONNECTION_ERR_CD,
              ErrorCdMsgConstants.FUNC_SERVER_CONNECTION_ERR_MSG
            )
            return true
          }
        }
        break

      default:
        // エラー001と002をチェックする
        return this.checkToShowServerDisconnectionErrorMsg(error, displayCloseIconForServerErrorFlag)
    }
  }

  /**
   * オフラインメッセージ表示チェック。
   *
   * @returns true: オフライン, false: オンライン
   */
  static checkToShowOfflineMsg() {
    if (!navigator.onLine) {
      FlashMessage.getInstance().showDisconnectionErrorCdMsg(ErrorCdMsgConstants.FUNC_NETWORK_PROXY_SERVER_CONNECTION_ERR_CD, ErrorCdMsgConstants.FUNC_NETWORK_PROXY_SERVER_CONNECTION_ERR_MSG)
      return true
    }
    return false
  }

  /**
   * サーバー切断表示チェック。
   *
   * @param {ErrorResponse} error エラー応答
   * @param {boolean} displayCloseIconForServerErrorFlag サーバーエラーフラグのクローズアイコン表示
   * @returns true: サーバーの切断, false: サーバー接続
   */
  static checkToShowServerDisconnectionErrorMsg(error, displayCloseIconForServerErrorFlag) {
    const serverDisconnectionMsg = this.getServerDisconnectionMsg(error)
    if (serverDisconnectionMsg) {
      FlashMessage.getInstance().showDisconnectionErrorMsg(serverDisconnectionMsg, displayCloseIconForServerErrorFlag)
      return true
    }
    return false
  }

  /**
   * サーバー切断ゲッター。
   *
   * @param {ErrorResponse} error エラー応答
   * @returns エラーメッセージ文字列
   */
  static getServerDisconnectionMsg(error) {
    if (!error) {
      return null
    }
    // バックエンドに接続できない、またはnginxに接続できない
    if (
      (error.message && error.message.includes('Network Error')) ||
      HTTPUtils.is504Error(error) ||
      HTTPUtils.is502Error(error) ||
      (error.message && error.message.includes('timeout of'))
    ) {
      if (store.getters.getIsUploading) {
        return this.buildErrorMessage(
          ErrorCdMsgConstants.FUNC_UPLOAD_TIMEOUT_ERR_CD,
          ErrorCdMsgConstants.FUNC_UPLOAD_TIMEOUT_ERR_MSG
        )
      }
      return this.buildErrorMessage(
        ErrorCdMsgConstants.FUNC_SERVER_CONNECTION_ERR_CD,
        ErrorCdMsgConstants.FUNC_SERVER_CONNECTION_ERR_MSG
      )
    }

    return null
  }
}



// WEBPACK FOOTER //
// ./src/_helpers/error-message.util.js